import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyUnescoaiethicsMode({ brand, today, Copy }: ModeRendererProps) {
  // UNESCO gradient: ethical principles spectrum
  const unescoGradient = (
    <defs>
      <linearGradient id="unescoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#009EDB" />
        <stop offset="50%" stopColor="#4CAF50" />
        <stop offset="100%" stopColor="#FFA726" />
      </linearGradient>
    </defs>
  );

  // Principle vertices: 10 AI ethics principles
  const principleVertices: JSX.Element[] = [];
  const principles = [
    "Human Rights",
    "Transparency",
    "Accountability",
    "Fairness",
    "Privacy",
    "Diversity",
    "Sustainability",
    "Solidarity",
    "Safety",
    "Well-being"
  ];
  
  for (let i = 0; i < 10; i++) {
    const angle = (i * Math.PI * 2) / 10 - Math.PI / 2;
    const radius = 220;
    const x = 397 + radius * Math.cos(angle);
    const y = 561.5 + radius * Math.sin(angle);
    principleVertices.push(
      <g key={`principle-${i}`}>
        <circle cx={x} cy={y} r={20} fill="url(#unescoGrad)" opacity={0.5} />
        <circle cx={x} cy={y} r={14} fill="none" stroke="url(#unescoGrad)" strokeWidth={2} />
      </g>
    );
  }

  // Consensus facets: interconnected principles
  const consensusFacets: JSX.Element[] = [];
  for (let i = 0; i < 10; i++) {
    const angle1 = (i * Math.PI * 2) / 10 - Math.PI / 2;
    const radius = 220;
    const x1 = 397 + radius * Math.cos(angle1);
    const y1 = 561.5 + radius * Math.sin(angle1);
    
    for (let j = i + 1; j < Math.min(i + 4, 10); j++) {
      const angle2 = (j * Math.PI * 2) / 10 - Math.PI / 2;
      const x2 = 397 + radius * Math.cos(angle2);
      const y2 = 561.5 + radius * Math.sin(angle2);
      consensusFacets.push(
        <line
          key={`facet-${i}-${j}`}
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke="url(#unescoGrad)"
          strokeWidth={1}
          opacity={0.2}
        />
      );
    }
  }

  // Normative frames: ethical boundaries
  const normativeFrames: JSX.Element[] = [];
  for (let i = 0; i < 8; i++) {
    const size = 120 + i * 45;
    const x = 397 - size / 2;
    const y = 561.5 - size / 2;
    normativeFrames.push(
      <rect
        key={`frame-${i}`}
        x={x}
        y={y}
        width={size}
        height={size}
        fill="none"
        stroke="url(#unescoGrad)"
        strokeWidth={1.5}
        opacity={0.3}
        rx={12}
      />
    );
  }

  // Ethical lattice background
  const ethicalLattice: JSX.Element[] = [];
  for (let i = 0; i < 16; i++) {
    const y = 100 + i * 58;
    ethicalLattice.push(
      <line
        key={`lat-h-${i}`}
        x1={70}
        y1={y}
        x2={724}
        y2={y}
        stroke="#009EDB"
        strokeWidth={0.5}
        opacity={0.2}
      />
    );
  }
  for (let i = 0; i < 13; i++) {
    const x = 70 + i * 52;
    ethicalLattice.push(
      <line
        key={`lat-v-${i}`}
        x1={x}
        y1={100}
        x2={x}
        y2={1023}
        stroke="#009EDB"
        strokeWidth={0.5}
        opacity={0.2}
      />
    );
  }

  // Central UNESCO core
  const unescoCore = (
    <g opacity={0.9}>
      <circle cx={397} cy={561.5} r={100} fill="none" stroke="#FFA726" strokeWidth={3} />
      <circle cx={397} cy={561.5} r={70} fill="none" stroke="#4CAF50" strokeWidth={2} />
      <circle cx={397} cy={561.5} r={45} fill="none" stroke="#009EDB" strokeWidth={2} />
      <text
        x={397}
        y={565}
        fontFamily="monospace"
        fontSize={16}
        fontWeight="bold"
        fill="#FFFFFF"
        textAnchor="middle"
      >
        UNESCO
      </text>
      <text
        x={397}
        y={583}
        fontFamily="monospace"
        fontSize={12}
        fill="#FFFFFF"
        textAnchor="middle"
        opacity={0.8}
      >
        AI Ethics
      </text>
    </g>
  );

  return (
    <g>
      {unescoGradient}
      {ethicalLattice}
      {normativeFrames}
      {consensusFacets}
      {principleVertices}
      {unescoCore}
      <g className="mode-copy" transform="translate(48, 840)" fill="#FFFFFF" fontFamily="monospace">
        <text x={0} y={0} fontSize={18} fontWeight="bold">{Copy?.title}</text>
        <text x={0} y={22} fontSize={14}>{Copy?.subtitle}</text>
        <text x={0} y={44} fontSize={12} opacity={0.85}>{Copy?.date}</text>
      </g>
    </g>
  );
}
